var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeaWave3(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1905 210",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1905 16c-66 13-130 37-182 37-18 0-128-52-217-52-186 0-223 50-325 49-51-15-94-49-191-49-124 0-174 52-291 52S573 7 480 7 292 53 218 53 42 1 1 1H0v243h1905V16z",
    fill: "#3CA7AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14a131 131 0 0051 12C70 18 48 10 29 6l14 8zM432 10a521 521 0 0185 4l14 3 13 4 52 19c18 6 37 10 57 10-75-10-94-44-173-44l-48 4zM903 10a631 631 0 0183-5l16 1h8l8 1h8l8 1 8 2 16 3a484 484 0 0161 18l15 5 8 2 8 3c-42-17-85-41-168-41-33 0-61 4-87 9zM1510 6h8l8 1h9l33 5c23 3 45 8 67 13-40-12-87-24-129-24-61 0-106 5-142 12a1282 1282 0 01137-7h9z",
    fill: "#62BCB3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeaWave3);
export default __webpack_public_path__ + "static/media/sea-wave-3.f540bd4f8ea2e8bd1709139319c43eaa.svg";
export { ForwardRef as ReactComponent };